<template>
    <div>
        <BuyStackFlyout
            v-model:visible="isBuystackFlyoutOpened"
        />
        <WarningIconProp65Setup/>
        <div :class="{'page-overlay': true, 'active': form.processing}" aria-hidden="true">
            <div class="page-overlay__content">
                <LoadingIcon alt="loading" />
                <p class="headline-l text-rothcoWhite">We're processing your order. Please do not refresh your screen.</p>
            </div>
        </div>
        <header class="checkout">
            <a :href="homeRoute" aria-label="Rothco home page" class="rothco-logo">
                <RothcoLogo class="mobile-hidden" alt="rothco Logo"/>
                <RothcoLogoMobile class="desktop-hidden" alt="rothco Logo"/>
            </a>
            <div class="secure-checkout">
                <SecureCheckout alt="lock icon"/>
                <p class="text-rothcoBlack">Secure Checkout</p>
            </div>
            <DynamicDialog />

            <div v-if="notificationMessage" :class="{
                'global': true,
                'notification': true,
                'notification-error': notificationMessage.type === 'error',
                'notification-success': notificationMessage.type === 'success',
                'notification-info': notificationMessage.type === 'info',
                'notification-warning': notificationMessage.type === 'warning',
                'bg-rothcoBlack': notificationMessage.type === 'default'
                }">
                <p class="paragraph-default"> 
                    {{ notificationMessage.message }}
                </p>
            </div>
        </header>
        <div class="main-checkout-guest">
		<!-- ORDER SUMMARY MOBILE BAR -->
            <div class="mobile-order-summary-bar-wrapper">
                <div class="mobile-order-summary-bar">
                    <details class="accordion">
                        <summary class="paragraph-feature accordion-title" aria-controls="order-summary">
                            <div>
                                <p class="paragraph-details text-rothcoRed">Show Order Summary</p>
                                <ChevronRed class="icon"/>
                            </div>
                            <p class="price text-rothcoBlack">{{ formattedTotal }}
                            </p>

                        </summary>
                        <div class="accordion-content">
                            <section class="order-confirmation">
                                <OrderSummaryD2CCheckout
                                    :current-list="props.current_list"
                                    :selected-shipping-method="form.shipping_option"
                                    :list-items="checkoutResource.items"
                                    :logged-in="props.user?.email"
                                    v-model:formattedTotal="formattedTotal"
                                    v-model:tax="taxAmount"
                                    v-model:coupon-code="form.used_coupon"
                                    @openLoginTab="openLoginTab()"
                                    @create-account-clicked="setQuickAccountCreate"
                                />
                            </section>
                        </div>
                    </details>
                </div>
            </div>
            <!-- FREE SHIPPING BAR MOBILE-->
            <div class="mobile-free-shipping-bar-wrapper flex-column desktop-hidden">
                <div v-if="['AK','HI'].includes(form.shipping_state)" class="mobile-free-shipping-bar">
                    <p>Free shipping only applies to the contiguous United States of America</p>
                </div>
                <div v-else class="mobile-free-shipping-bar" style="border-bottom: none">
                    <FreeShipping class="modal__footer--shipping-icon" alt="Free shipping" />
                    <p class="title-s text-rothcoBlack">{{ promotionalShippingMessage }}</p>
                </div>
                <div v-if="!['AK','HI'].includes(form.shipping_state)" class="bg-rothcoRed" :style="{'height': '0.125rem',width: promotionalShippingProgress + '%'}"></div>
            </div>
            <!-- CHECKOUT GUEST -->
            <section class="checkout-guest-section sticky">
                <div class="section-header">
                    <p class="headline-l text-rothcoBlack title">Checkout</p>
                    <p class="paragraph-default">Information here is for retail purchase only. <a :href="route('index.becomeADealer')" target="_blank" aria-label="Wholesale inquiries">Wholesale inquiries click here.</a></p>
                </div>
                <div v-if="restrictedItemMessage" class="container-section column">
                    <p class="paragraph-details invalid-state" style="font-size:1rem;">{{ restrictedItemMessage }}</p>
                </div>
                <div class="authorization">
                    <div class="authorization-tabs authorization_tabset tabset">
                        <div v-if="!props.user || !props.user.email" class="authorization_tabset-controls">
                            <div class="authorization_tabset-title-1">
                                <input v-model="authorizationTab" type="radio" name="tabset" id="tab1" value="tab1" aria-controls="login" checked>
                                <label class="headline-s" for="tab1">Guest Checkout</label>
                            </div>
                            <div class="authorization_tabset-title-2">
                                <input v-model="authorizationTab" type="radio" name="tabset" id="tab2" value="tab2" aria-controls="description">
                                <label class="headline-s" for="tab2">Log Into Account</label>
                            </div>
                        </div>
                        <div v-else class="authorization_tabset-controls" style="display:none;">
                            <div style="display: none;" class="authorization_tabset-title-1">
                                <input type="radio" name="tabset" id="tab1" aria-controls="login" checked>
                                <label class="headline-s" for="tab1">Contact</label>
                            </div>
                        </div>
                        <div class="authorization_tabset-panels">
                            <section id="guest_checkout" class="authorization_tabset-panel">
                                <form class="authorization-form">
                                    <div v-if="!!props.user.email" class="authorization-form" style="width: 100%; margin-bottom:0;">
                                        <div class="flex-column">
                                            <p class="title-l text-rothcoBlack">Contact</p>
                                            <div class="flex-row space-between">
                                                <div class="flex-column">
                                                    <p class="paragraph-details">{{ props.user.email }}</p>
                                                </div>
                                                <RothcoCta type="button" :href="logoutRoute" class="primary">Logout</RothcoCta>
                                            </div>
                                        </div>
                                        <div class="authorization-form" style="margin-bottom:0;">
                                            <div class="email-and-password">
                                                <div class="authorization-input_label" style="margin-top: 0.5rem;">
                                                    <InputMask 
                                                        :aria-required="true"
                                                        @focus="toggleLoginPlaceholder('guest_phone_logged_in')"
                                                        @blur="toggleLoginPlaceholder('guest_phone_logged_in')"
                                                        id="guest_phone_logged_in" v-model="form.phone_number" mask="(999) 999-9999" :class="{
                                                            'authorization-guest_phone_input': true,
                                                            'invalid-state-input': form.errors.phone_number != null,
                                                            'flex': true,
                                                        }"
                                                        :placeholder="!loginPlaceholdersHidden.get('guest_phone_logged_in') ? 'Phone Number *' : ''" 
                                                        fluid 
                                                    />
                                                    <label
                                                    :class="{'invalid-state': form.errors.phone_number}"
                                                    for="guest_phone_logged_in"><p>Phone Number *</p></label>
                                                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.phone_number">{{ form.errors.phone_number }}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="!props.user || !props.user.email" class="email-and-password">
                                        <EmailInput 
                                            v-model="form.email" 
                                            :errors="form.errors.email ?? emailUpdateError" 
                                            id="guest_email" 
                                            placeholder="Email *"
                                            :aria-required="true"
                                        />
                                        <div class="authorization-input_label">
                                            <InputMask 
                                                :aria-required="true"
                                                @focus="toggleLoginPlaceholder('guest_phone')"
                                                @blur="toggleLoginPlaceholder('guest_phone')"
                                                id="guest_phone" v-model="form.phone_number" mask="(999) 999-9999" :class="{
                                                'authorization-guest_phone_input': true,
                                                'invalid-state-input': form.errors.phone_number != null
                                            }"
                                            :placeholder="!loginPlaceholdersHidden.get('guest_phone') ? 'Phone Number *' : ''" 
                                            fluid />
                                            <label
                                            :class="{'invalid-state': form.errors.phone_number}"
                                            for="guest_phone"><p>Phone Number *</p></label>
                                            <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.phone_number">{{ form.errors.phone_number }}</p></div>
                                        </div>
                                    </div>
                                    <div v-if="!props.user || !props.user.email" class="guest-checkout-checkboxes-container">
                                        <div class="container-section create-account">
                                            <div class="create-account-container">
                                                <input type="checkbox" id="create_account" aria-label="Quickly create an account" class="mt-checkbox" value="c" v-model="form.quick_account_create">
                                                <p class="paragraph-details"><span class="bold">Quickly create an account</span> without leaving checkout & save time on future orders</p>
                                            </div>
                                            <div class="input-folder"><p class="input-support-text invalid-state" v-if="quickCreateUserErrors">{{quickCreateUserErrors}}</p></div>
                                            <div class="password-form-fields toggle-on-check">
                                                <PasswordInput
                                                    :aria-required="true"
                                                    v-model="form.password" 
                                                    :errors="form.errors.password" 
                                                    id="signupPasswordInput_guest_password"
                                                    placeholder="Password *"
                                                />
                                                <PasswordInput
                                                    :aria-required="true"
                                                    v-model="form.confirm_password" 
                                                    :errors="form.errors.confirm_password" 
                                                    id="signupPasswordInput_guest_confirm_password"
                                                    placeholder="Confirm Password *"
                                                />
                                            </div>
                                        </div>
                                        <div class="container-section column">
                                            <p class="paragraph-details">Be the first to know about special discounts & new gear via Rothco-exclusive emails & SMS!</p>
                                            <div class="sign-up-checkboxes">
                                                <div class="container">
                                                    <input type="checkbox" v-model="form.sms_signup" id="signup_sms" aria-label="Sign up for SMS"/>
                                                    <p class="paragraph-details">Sign up for SMS</p>
                                                </div>
                                                <div class="container">
                                                    <input type="checkbox" id="signup_email" v-model="form.newsletter_signup" aria-label="Sign up for email"/>
                                                    <p class="paragraph-details">Sign up for email</p>
                                                </div>
                                            </div>
                                            <p class="paragraph-caption toggle-on-check">
                                                By checking this box, you agree to receive recurring automated marketing text messages (e.g. AI content, cart reminders) from Rothco at the number you provide. Consent not a condition of purchase. We may share info with service providers per our Privacy Policy. Reply HELP for help & STOP to cancel. Msg frequency varies. Msg & data rates may apply. By checking this box, you also agree to our <a class="paragraph-caption" href="https://attnl.tv/t/ctj" target="_blank" aria-label="Learn more about messaging terms and conditions">Terms</a> (incl. arbitration) & <a href="https://attnl.tv/p/ctj" class="paragraph-caption" aria-label="Learn more about messaging privacy policy" target="_blank">Privacy Policy</a>
                                            </p>
                                        </div>
                                    </div>
                                    <ShippingInfoD2CCheckout 
                                        :user="props.user"
                                        v-model:firstName="form.shipping_first_name"
                                        v-model:lastName="form.shipping_last_name"
                                        v-model:phoneNumber="form.phone_number"
                                        v-model:address="form.shipping_address"
                                        v-model:address2="form.shipping_address2"
                                        v-model:city="form.shipping_city"
                                        v-model:state="selectedShippingState"
                                        v-model:zip="form.shipping_zip"
                                        v-model:shipping_is_po_box="form.shipping_is_po_box"
                                        :addresses="props.checkoutResource.addresses"
                                        :is-valid="isValid"
                                        :tax-error-message="taxErrorMessage"
                                        :is-different="isDifferent"
                                        :use-suggested-address="useSuggestedAddress"
                                        v-model:errors="form.errors"
                                        :regions="regionsMap"
                                        v-model:isNewAddress="isNewAddress"
                                        :open="props.user == '' ? true : checkoutResource.addresses.length == 0"
                                        @shippingAddressUpdated="trackViewedShipping"
                                    />
                                    <ShippingMethodD2CCheckout
                                        :user="props.user"
                                        v-model:selectedShippingMethod="form.shipping_option"
                                        :shippingMethods="shippingMethods"
                                        :cartTotal="orderLineTotalWithDiscount"
                                        @shippingUpdated="onShippingUpdated"
                                    />
                                    <PaymentMethodD2CCheckout
                                        :user="props.user"
                                        v-model:billing-first-name="form.billing_first_name"
                                        v-model:billing-last-name="form.billing_last_name"
                                        v-model:billing-address="form.billing_address"
                                        v-model:billing-address2="form.billing_address2"
                                        v-model:billing-city="form.billing_city"
                                        v-model:billing-state="form.billing_state"
                                        v-model:billing-zip="form.billing_zip"
                                        :credit-cards="props.checkoutResource.cards"
                                        v-model:selectedPaymentMethod="selectedPaymentMethod"
                                        v-model:cardNumber="form.card_number"
                                        v-model:expirationDate="form.card_expiration"
                                        v-model:securityCode="form.card_cvv"
                                        v-model:nameOnCard="form.card_name"
                                        v-model:useShippingAsBilling="useShippingAsBilling"
                                        v-model:saveCard="form.save_card"
                                        v-model:setAsDefault="form.mark_default_card"
                                        :errors="form.errors"
                                        :regions="regionsMap"
                                        :paypalAttempted="paypalAttempted"
                                        :stripe-publishable-key="props.stripePublishableKey"
                                        :total-amount="+completeOrderTotal"
                                        :canProcessStripeExpressCheckout="canProcessStripeExpressCheckout"
                                        @creditCardUpdated="onCreditCardUpdated"
                                        @stripe-express-checkout-success="handleStripeExpressCheckoutSuccess"
                                    />
                                    <div class="order-comments-container">
                                        <div class="textarea-folder">
                                            <textarea id="text-area" v-model="form.shipping_comment" class="input-folder--input"></textarea>
                                            <label class="paragraph-default" for="text-area">Order Comments (Optional)</label>
                                        </div>
                                    </div>
                                    <div ref="checkoutErrors" class="notification notification-error" v-if="form.errors.error">
                                        <CarbonShoppingCartError alt="Error!" />
                                        <p class="paragraph-details"><strong>Error:</strong> {{ form.errors.error }}</p>
                                    </div>
                                    <div ref="paymentErrors" class="notification notification-error" v-else-if="form.errors.payment">
                                        <CarbonShoppingCartError alt="Error!" />
                                        <p class="paragraph-details"><strong>Error:</strong> {{ form.errors.payment }}</p>
                                    </div>
                                    <div class="place-order-desktop">
                                        <button id="place_order_button" type="button" :disabled="!allowPlaceOrder" :class="allowPlaceOrder ? `primary` : `bg-rothcoMedGray text-rothcoCharcoal`" aria-label="Place your order" @click="placeOrder">
                                            Place Order
                                        </button>
                                        <p class="paragraph-details">By clicking “Place Order,” you agree to Rothco’s <a target="_blank" :href="termsAndConditionsRoute" class="paragraph-details text-rothcoText" aria-label="View Terms & Conditions">Terms & Conditions.</a></p>
                                    </div>
                                </form>
                            </section>
                            <section id="login" class="authorization_tabset-panel">
                                <p class="authorization-login_subtitle">Log into your Rothco account for expedited checkout, enhanced product recommendations, and more!</p>
                                <Login :isFlyout="true" :d2cOnly="true" ref="login" @setAsLoggedIn="userLoggedIn()"/>
                                <div class="guest-checkout-checkboxes-container">							
                                    <div class="container-section column">
                                        <p class="paragraph-details">Be the first to know about special discounts & new gear via Rothco-exclusive emails & SMS!</p>
                                        <div class="sign-up-checkboxes">
                                            <div class="container">
                                                <input type="checkbox" id="signup_sms" v-model="form.sms_signup" aria-label="Sign up for SMS" />
                                                <p class="paragraph-details">Sign up for SMS</p>
                                            </div>
                                            <div class="container">
                                                <input type="checkbox" id="signup_email" v-model="form.newsletter_signup" aria-label="Sign up for email" />
                                                <p class="paragraph-details">Sign up for email</p>
                                            </div>
                                        </div>
                                        <p class="paragraph-caption toggle-on-check">By submitting this form and signing up for texts, you consent to receive marketing text messages (e.g. promos, cart reminders) from Rothco at the number provided. Msg & data rates may apply. <a href="#" class="paragraph-caption" aria-label="Learn more about text message consent">Learn More</a></p>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                
            </section>
            <!-- ORDER SUMMARY CONFIRMATION -->
            <section class="order-summary sticky">
                <div class="desktop-free-shipping-bar-wrapper flex-column mobile-hidden">
                    <div class="desktop-free-shipping-bar" style="border-bottom: none;">
                        <FreeShipping class="modal__footer--shipping-icon" alt="Free shipping" />
                        <p class="title-s text-rothcoBlack">{{ promotionalShippingMessage }}</p>
                    </div>
                    <div v-if="!['AK','HI'].includes(form.shipping_state)" class="bg-rothcoRed" :style="{'height': '0.125rem',width: promotionalShippingProgress + '%'}"></div>
                </div>
                <OrderSummaryD2CCheckout
                    :current-list="props.current_list"
                    :selected-shipping-method="form.shipping_option"
                    :list-items="checkoutResource.items"
                    :restricted-items="restrictedItems"
                    :coupon-items="couponItems"
                    :logged-in="props.user?.email"
                    v-model:formattedTotal="formattedTotal"
                    v-model:tax="taxAmount"
                    v-model:coupon-code="form.used_coupon"
                    @openLoginTab="openLoginTab()"
                    @create-account-clicked="setQuickAccountCreate"
                />
            </section>
            <div class="place-order-mobile">
                <button type="button" :disabled="form.processing || Object.keys(form.errors).length != 0 || emailUpdateBlocksOrder" @click="placeOrder" :class="Object.keys(form.errors).length == 0 && !emailUpdateBlocksOrder ? `primary` : `bg-rothcoMedGray text-rothcoCharcoal`" aria-label="Place order">
                    Place Order
                </button>
                <p class="paragraph-details">By clicking “Place Order,” you agree to Rothco’s <a target="_blank" :href="termsAndConditionsRoute" class="paragraph-details text-rothcoText" aria-label="View Terms & Conditions">Terms & Conditions.</a></p>
            </div>
            <div class="order-footer-links-mobile">
                <a :href="helpRoute" target="_blank" aria-label="Get help">Need Help?</a>
                <a :href="returnPolicyRoute" target="_blank" aria-label="View return policy">Return policy</a>
                <a :href="privacyPolicyRoute" target="_blank" aria-label="View privacy policy">Privacy policy</a>
                <a :href="termsAndConditionsRoute" target="_blank" aria-label="View terms of service">Terms of service</a>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import ShippingInfoD2CCheckout from "../components/ShippingInfoD2CCheckout.vue";
    import ShippingMethodD2CCheckout from "../components/ShippingMethodD2CCheckout.vue";
    import PaymentMethodD2CCheckout from "../components/PaymentMethodD2CCheckout.vue";
    import OrderSummaryD2CCheckout from "../components/OrderSummaryD2CCheckout.vue";
    import BuyStackFlyout from "../components/BuyStackFlyout.vue";
    import TwoFactorAuthenticationForm from "../components/TwoFactorAuthenticationForm.vue";
    import Login from "@/components/auth/forms/Login.vue";
    import { formatPrice } from "@/helpers/composables/usePriceFormatting";
    import {
        computed,
        ref,
        onMounted,
        onBeforeUnmount,
        watch,
        toRefs,
        nextTick,
        inject,
        onUnmounted
    } from "vue";
    import { loadScript } from "@paypal/paypal-js";
    import { useForm } from "@/helpers/composables/useForm";
    import { storeToRefs } from "pinia";
    import { useSettingsStore } from "@/store/settings";
    import { useAddressValidation } from "@/helpers/composables/useAddressValidation";
    import { useFetch } from "@/helpers/composables/useFetch";
    // import { route } from "ziggy-js";
    import { string, number, date, boolean, object} from 'yup';
    import { v4 as uuidv4 } from "uuid";
    import InputMask from 'primevue/inputmask';
    import DynamicDialog from "primevue/dynamicdialog";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { useCheckoutD2CStore } from '@/store/checkoutD2CStore';
    import { useWindowScroll, useStorage, watchDebounced } from '@vueuse/core';
    import EmailInput from "@/components/EmailInput.vue";
    import PasswordInput from "@/components/PasswordInput.vue";
    import LoadingIcon from "@icons/loading.svg";
    import RothcoLogo from "@icons/rothcoLogo.svg";
    import RothcoLogoMobile from "@icons/rothco-mobile.svg";
    import SecureCheckout from "@icons/secure-checkout.svg";
    import ChevronRed from "@icons/chevronRed.svg";
    import FreeShipping from "@icons/free-shipping.svg";
    import CarbonShoppingCartError from "@icons/carbon_shopping-cart-error.svg";
    import WarningIconProp65Setup from "@icons/warning-icon-setup.svg";
    import { router, usePage } from "@inertiajs/vue3";
    import useGoogleTagManager from "@/helpers/composables/google.ts";


    const beforeUnloadHandler = (event: BeforeUnloadEvent) => {
        event.preventDefault();
        event.returnValue = "";
    };
    let route = inject('route');
    let props = defineProps({
        ppClientId: {
            type: String,
            default: ""
        },
        stripePublishableKey: {
            type: String,
            required: true
        },
        current_list: {
            type: Object,
            default() {
                return {};
            }
        },
        user: {
            type: Object,
            default() {
                return {};
            }
        },
        checkoutResource: {
            type: Object,
            default() {
                return {};
            }
        },
        regions: {
            type: Array<Object>,
            default: [],
        },
        flash: {
            type: Object,
            default: ()=>{
                return {}
            }
        },
        free_shipping_amount: {
            type: Number,
            default: 0
        },
        errors: {
            type: Object,
            default(){
                return {}
            }
        },
        socialMediaCoupon: {
            type: String,
            default: null
        }
    });

    const { 
        getShippingRates, 
        checkRestrictions,
        recalculateTax, 
        reapplyCoupon,
        setTaxPayload, 
        reset:resetStore,
        clearCoupon
    } = useCheckoutD2CStore();
    resetStore();
    let { shippingStateForRates, taxAmount, taxErrorMessage, isLoadingCalculation, shippingRates, couponInformation, restrictions, isUpdatingCartItem } = storeToRefs(useCheckoutD2CStore())
    let { gtmBeginCheckoutEvent, gtmAddShippingInfoEvent, gtmAddPaymentInfoEvent } = useGoogleTagManager();
    const settingsStore = useSettingsStore();
    const { setList, setNotificationMessage, setFreeShippingAmount } = settingsStore;
    let { freeShippingMessage, freeShippingProgressPercentage, notificationMessage, isBuystackFlyoutOpened } = storeToRefs(settingsStore);

    let { calculatePromotionalShippingProgress } = settingsStore;

    // Calculate promotional shipping progress
    let promotionalShippingProgress = computed(()=>{
        let cost = usePage().props.checkoutResource.shipping_rates.freeshippingmsg.order_min;
        return calculatePromotionalShippingProgress(cost);
    });

    let promotionalShippingMessage = computed(()=>{
        return usePage().props.checkoutResource.shipping_rates.freeshippingmsg.message;
    });

    setList(props.current_list);
    watch(()=>props.current_list.total, (newVal)=>{
        setList(props.current_list);
    })

    const { y } = useWindowScroll({ behavior: 'smooth' })
    const scrollToTop = ()=>{
        y.value = 0;
    }

    const checkoutErrors = ref(null);
    const paymentErrors = ref(null);

    let formattedTotal = ref("");
    let useShippingAsBilling = ref(true);

    const couponCode = useStorage("coupon",null);

    if (props.socialMediaCoupon) {
        couponCode.value = props.socialMediaCoupon;
    }

    const restrictedItemMessage = computed(()=>{
        return props.flash?.message?.message;
    })

    const regionsMap = computed(()=>{
        return props.regions.filter((region)=>(region.country == 'USA')).map((region)=>({
            ...region, value: region.code, key: region.code
        }))
    })

    const orderLineTotalWithDiscount = computed(()=> {     
        const couponItemPrice = couponInformation?.value?.items
            ?.filter(item => item.item_added_by_coupon === true)
                .reduce((sum, item) => sum + ((+item.priceWithoutDiscount) || 0), 0) ?? 0;

        return (+props.current_list.total || 0) + couponItemPrice - +(couponInformation?.value?.discountAmount ?? 0);
    })

    // Shipping Methods
    let shippingMethods = computed(() => {
        if (props.checkoutResource) {
            let methods = props.checkoutResource?.shipping_methods;
            let rates = shippingRates?.value ?? props.checkoutResource?.shipping_rates
            let rateNames = Object.keys(rates).filter((r) => r !== 'freeshippingmsg');
            let result = methods.map((method) => {
                return {
                    name: method.display,
                    cost: rates?.[rateNames.find((rate) => rate == method.value)],
                    methodValue: method.value,
                    code: method.defaultMethod,
                };
            });
            
            // Filter out 2-day/3-day shipping if cart total is over the threshold
            const cartTotal = orderLineTotalWithDiscount.value;
            if (cartTotal > usePage().props.d2c_expedited_shipping_max_cart_total) {
                result = result.filter((method) => {
                    return method.methodValue !== 'twoday' && method.methodValue !== 'threeday';
                });
            }
            
            return result;
        }
        else return [];
    });

    // Form

    const phoneCheck = function (phoneNumber) {
        phoneNumber = phoneNumber.replace(/\D/g, "");
        return phoneNumber.length == 10;
    };

    const form = useForm({
        useInertia: true,
        // Server bag keys from checkout redirects; not Yup schema fields.
        preserveErrorKeys: ["payment", "error"],
        schema: object({
            card_id: string().notRequired().default(null),
            email: string().email('Please enter a valid email').required('Email is required').default(''),
            phone_number: string().required('Phone number is required').test({
                name: "phone_number",
                message: "Invalid phone number",
                test: (value) => {
                    return phoneCheck(value);
                }
            }).default(''),
            
            quick_account_create: boolean().notRequired().default(false),
            password: string().when('quick_account_create', {
                is: true,
                then: ()=> string()
                    .required('The password field is required')
                    .test('password-strength', '', (value, ctx) => {
                        if (!value) return true;
                        let messages = [];
                        let weakPasswordMessage;
                        if (!/[A-Z]/.test(value)) messages.push('at least one uppercase letter');
                        if (!/[a-z]/.test(value)) messages.push('at least one lowercase letter');
                        if (!/[0-9]/.test(value)) messages.push('at least one number');
                        if (!/[#?!@$%^&*-]/.test(value)) messages.push('at least one special character (# ? ! @ $  % ^ & * -)');
                        if (/\s/.test(value)) messages.push('no spaces');
                        if (value.length < 8) messages.push('at least 8 characters');
                        if (/password/i.test(value)) weakPasswordMessage = 'Your password is too weak.';
                        if (messages.length || weakPasswordMessage) return ctx.createError({ message: messages.length > 0 ? `Password must contain ${messages.join(', ')}.${weakPasswordMessage ? " " + weakPasswordMessage : ""}` : weakPasswordMessage });
                        return true;
                    }).default(""),
                otherwise: ()=> string().notRequired()
            }),
            confirm_password: string().when('quick_account_create', {
                is: true,
                then: ()=> string().required('Password confirmation is required').test('match', 'Password confirmation does not match', (value)=>{
                    return value === form.password;
                }),
                otherwise: ()=> string().notRequired()
            }),

            sms_signup: boolean().default(false),
            newsletter_signup: boolean().default(false),
            used_coupon: string().notRequired().default(couponCode.value),
            shipping_first_name: string().required('First Name / Company is required').default(''),
            shipping_last_name: string().notRequired().default(''),
            shipping_address: string().required('Address is required').default(''),
            shipping_address2: string().notRequired().default(''),
            shipping_city: string().required('City is required').default(''),
            shipping_state: string().required('State is required').default(''),
            shipping_zip: string().required('Postal Code is required').default(''),
            shipping_comment: string().notRequired().default(''),
            add_billing_info: string().required().default('0'),
            billing_first_name: string().when('add_billing_info', {
                is: (val)=>(val == '1'),
                then: (schema)=>schema.required('Billing First Name is required'),
                otherwise: (schema)=>schema.notRequired(),
            }).default(''),
            billing_last_name: string().notRequired().default(''),
            billing_address: string().when('add_billing_info', {
                is: (val)=>(val == '1'),
                then: (schema)=>schema.required('Billing Address is required'),
                otherwise: (schema)=>schema.notRequired(),
            }).default(''),
            billing_address2: string().notRequired().default(''),
            billing_city:  string().when('add_billing_info', {
                is: (val)=>(val == '1'),
                then: (schema)=>schema.required('Billing City is required'),
                otherwise: (schema)=>schema.notRequired()
            }).default(''),
            billing_state: string().when('add_billing_info', {
                is: (val)=>(val == '1'),
                then: (schema)=>schema.required('Billing State is required'),
                otherwise: (schema)=>schema.notRequired()
            }).default(''),
            billing_zip: string().when('add_billing_info', {
                is: (val)=>(val == '1'),
                then: (schema)=>schema.required('Billing Postal Code is required'),
                otherwise: (schema)=>schema.notRequired()
            }).default(''),
            payment_method: string().required().test({
                name: 'expired-card',
                message: 'Selected Card is expired.',
                test: ()=>{
                    if(selectedExistingCreditCard.value){
                        return !isCardExpired(selectedExistingCreditCard.value?.cc_exp)
                    }else{
                        return true;
                    }
                }
            }).default("card"),
            card_number: string().when('payment_method', {
                is: (val)=> (val == 'card'),
                then: (schema)=>schema.required('Card Number is required').test({
                    name: "card_number",
                    message: "Invalid card number",
                    test: (value) => {
                        return luhnCheck(value);
                    }
                }),
                otherwise: (schema)=>schema.notRequired()
            }).default(''),
            card_name: string().when('payment_method', {
                is: (val) => (val == 'card'),
                then: (schema)=>schema.required('Name is required'),
                otherwise: (schema)=>schema.notRequired()
            }).default(''),
            card_expiration: string().when('payment_method', {
                is: (val) => (val == 'card'),
                then: (schema)=>schema.required('Expiration date is required').test({
                    name: "card_expiration",
                    message: "Expiration date is required",
                    test: (value) => {
                        const regex = /^(0[1-9]|1[0-2])\/(\d{2}|\d{4})$/;
                        const match = value?.match(regex);
                        return !!match;
                    }
                }).test({
                    name: "card_expiration",
                    message: "Card is expired",
                    test: (value) => {
                        let month = value?.split('/')?.[0] ?? 0;
                        let year = value?.split('/')?.[1] ?? 0;
                        let currentYear = (new Date().getFullYear() % 100);
                        let currentMonth = new Date().getMonth() + 1;
                        return +year > +currentYear || (+year === +currentYear && +month >= +currentMonth); 
                    }
                }),
                otherwise: (schema)=>schema.notRequired()
            }).default(''),
            card_cvv: string().when('payment_method', {
                is: (val) => (val == 'card'),
                then: (schema) => schema.required('Please enter your CVV code'),
                otherwise: (schema)=>schema.notRequired()
            }).default(''),
            card_alias: string().notRequired().default(''),
            paypal_order_id: string().when('payment_method', {
                is: (val)=> (val == 'paypal'),
                then: (schema)=>schema.required('There was an error with your PayPal order. Please try again.'),
                otherwise: (schema)=>schema.notRequired()
            }).default(null),
            paypal_amount: number().when('payment_method', {
                is: (val)=> (val == 'paypal'),
                then: (schema)=>schema.required('Missing order total for PayPal.'),
                otherwise: (schema)=>schema.notRequired()
            }).default(null),
            stripe_payment_intent_id: string().when('payment_method', {
                is: (val)=> (val == 'stripe_express_checkout'),
                then: (schema)=>schema.required('Stripe Express Checkout payment data is required.'),
                otherwise: (schema)=>schema.notRequired()
            }).default(null),
            shipping_option: object({
                name: string().required(),
                cost: number().required(),
                methodValue: string().required()
            }).required()
                .default(shippingMethods.value[0]),
            list_id: string().required().default(props.checkoutResource.list_id),
            promo_item: string().notRequired().default(props.checkoutResource?.promoItem?.item_variation_id),
            shipping_is_po_box: string().default("0"),
            save_card: boolean().default(false),
            mark_default_card: boolean().default(false),
            source: string().default('checkout'),
        })
    });

    watch(couponCode, (newVal)=>{
        form.used_coupon = newVal;
    }, {immediate: true})

    const loginPlaceholdersHidden = ref(new Map());
    function toggleLoginPlaceholder(id) {
        if(!loginPlaceholdersHidden.value.has(id)) {
            loginPlaceholdersHidden.value.set(id, true);
        }else{
            loginPlaceholdersHidden.value.set(id, !loginPlaceholdersHidden.value.get(id));
        }
    }

    const setQuickAccountCreate = () => {
        authorizationTab.value = 'tab1';
        form.quick_account_create = true;
    };

    const { user } = toRefs(props);
    watch(user, (newVal)=>{
        if (newVal && newVal.email) {
            form.email = newVal.email;
        }
        if(newVal && newVal.phone_number){
            form.phone_number = newVal.phone_number;
        }
    },{deep: true, immediate: true})
    
    const checkoutTrackingHeaders = {
        beforeFetch: (ctx) => {
            ctx.options.headers = {
                ...ctx.options.headers,
                'Accept': 'application/json',
            };
            return ctx;
        },
    };

    const trackedCheckoutSteps = {
        viewedShipping: false,
        enteredShipInfo: false,
        enteredBillInfo: false,
    };

    const trackViewedShipping = () => {
        if (trackedCheckoutSteps.viewedShipping) {
            return;
        }
        trackedCheckoutSteps.viewedShipping = true;
        useFetch(route('shipping.viewed'), checkoutTrackingHeaders).get();
    };

    const trackEnteredInfo = (type) => {
        const flag = type === 'entered_ship_info' ? 'enteredShipInfo' : 'enteredBillInfo';
        if (trackedCheckoutSteps[flag]) {
            return;
        }
        trackedCheckoutSteps[flag] = true;
        useFetch(route('updatelist'), checkoutTrackingHeaders).post({ type }).json();
    };

    const emailUpdateError = ref(null);
    const emailUpdatePending = ref(false);
    const emailUpdateBlocksOrder = computed(() => emailUpdatePending.value || !!emailUpdateError.value);
    let emailUpdateRequestId = 0;

    watchDebounced(() => form.email, (newVal) => {
        emailUpdateError.value = null;
        if(newVal != null && newVal != ''){
            const requestId = ++emailUpdateRequestId;
            emailUpdatePending.value = true;
            useFetch(route('emailupdate'), {
                ...checkoutTrackingHeaders,
                afterFetch: (ctx) => {
                    if (requestId !== emailUpdateRequestId) {
                        return ctx;
                    }
                    emailUpdatePending.value = false;
                    if(ctx?.data?.status === false){
                        emailUpdateError.value = ctx.data.message ?? null;
                    }
                    return ctx;
                },
                onFetchError: (ctx) => {
                    if (requestId !== emailUpdateRequestId) {
                        return ctx;
                    }
                    emailUpdatePending.value = false;
                    return ctx;
                },
            }).post({
                email: newVal
            }).json();
        } else {
            emailUpdateRequestId++;
            emailUpdatePending.value = false;
        }
    }, {debounce: 1000});

    // Payment Methods
    let selectedExistingCreditCard = ref();
    const luhnCheck = function (cardNumber) {
        cardNumber = cardNumber.replace(/\D/g, "");
        let sum = 0;
        let numDigits = cardNumber.length;
        let parity = numDigits % 2;
        for (let i = 0; i < numDigits; i++) {
            let digit = parseInt(cardNumber.charAt(i));
            if (i % 2 == parity) digit *= 2;
            if (digit > 9) digit -= 9;
            sum += digit;
        }
        return sum % 10 == 0;
    };

    const isCardExpired = (expiry) => {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear() % 100;
        const cardMonth = parseInt(expiry.substring(0, 2), 10);
        const cardYear = parseInt(expiry.substring(2, 4), 10);
        return cardYear < currentYear || (cardYear === currentYear && cardMonth < currentMonth);
    };

    let restrictionData = ref([]);

    let restrictionPayload = computed(() => ({
        final_address: {
            country_alpha3_code: 'USA',
            region: form.shipping_state
        },
        options: {
            country_alpha3_code: 'USA',
            region: form.shipping_state,
            postal_code: form.shipping_zip,
            customer: '800B2C',
            is_quote: false,
            shipping_method: form.shipping_option.code
        },
        order_skus: props.checkoutResource.items.map((item) => ({
            quantity: item.quantity,
            price: item.price,
            upc: item.variation.upc
        }))
    }));

    let restrictedItems = computed(() => {
        return props.checkoutResource.items.reduce((acc, item) => {    
            let restrictedSkus = restrictions.value?.data?.skus;
            if (restrictedSkus) {
                restrictedSkus = Object.values(restrictedSkus);
                let restrictedSku = restrictedSkus.find(
                    (restriction) => restriction.upc == item.variation.upc
                );
                if (restrictedSku?.is_restricted) {
                    acc.push(item);
                }
            }
            return acc;
        }, []);
    });

    watch([() => form.shipping_state, () => form.shipping_zip, () => form.shipping_option, () => props.checkoutResource.items], async () => {
        checkRestrictions(restrictionPayload.value);
    }, { immediate: true, deep: true });

    let selectedPaymentMethod = ref('card');

    watch(selectedPaymentMethod, (newVal)=>{
        if(newVal == "card"){
            form.paypal_order_id = null;
            form.paypal_amount = null;
        }else if(newVal == "paypal" || newVal == "stripe_express_checkout"){
            form.card_number = null;
            form.card_expiration = null;
            form.card_cvv = null;
            form.card_name = null;
            form.card_alias = null;
            form.card_id = null;
        }
    })

    watch(() => form.card_cvv, (newVal) => {
        if (newVal) {
            trackEnteredInfo("entered_bill_info");
        }
    });

    watch(
        [selectedPaymentMethod, useShippingAsBilling],
        ([paymentMethodNewVal, useShippingAsBillingNewVal]) => {
            if (!["paypal", "gift", "card"].includes(paymentMethodNewVal)) {
                selectedExistingCreditCard.value =
                    props.checkoutResource.cards.find(
                        (card) => card.consumer_credit_card_id == paymentMethodNewVal
                    );
                form.payment_method = paymentMethodNewVal;
                if (selectedExistingCreditCard.value) {
                    trackEnteredInfo("entered_bill_info");
                }
            } else if (
                ["paypal", "gift", "card"].includes(paymentMethodNewVal)
            ) {
                selectedExistingCreditCard.value = null;
                form.payment_method = paymentMethodNewVal;
            }
            if (useShippingAsBillingNewVal == true) {
                form.add_billing_info = "0";
                form.billing_first_name = null;
                form.billing_last_name = null;
                form.billing_address = null;
                form.billing_address2 = null;
                form.billing_city = null;
                form.billing_state = '';
                form.billing_zip = null;
            } else {
                form.add_billing_info = "1";
                form.billing_first_name = null;
                form.billing_last_name = null;
                form.billing_address = null;
                form.billing_address2 = null;
                form.billing_city = null;
                form.billing_state = '';
                form.billing_zip = null;
            }
            if(['paypal', 'gift'].includes(paymentMethodNewVal)){
                gtmAddPaymentInfoEvent(completeOrderTotal.value,);
            }
        }

      
    );    

    // Address 
    let isNewAddress = ref(false);

    let { reactiveAddress, isValid, isDifferent, useSuggestedAddress } =
        useAddressValidation({
            street1: form.shipping_address,
            street2: form.shipping_address2,
            city: form.shipping_city,
            state: form.shipping_state,
            postal_code: form.shipping_zip,
            country: "US"
        }, isNewAddress);

    watch(() => props.user.user_id, (newVal) => {
        if (!newVal) {
            isNewAddress.value = true;
        }
    },{
        immediate: false
    });
    

    const selectedShippingState = ref({});
    watch(selectedShippingState, (newVal)=>{
        form.shipping_state = newVal?.value;
    },{immediate: true})

    watch(
        () => [
            form.shipping_address,
            form.shipping_city,
            form.shipping_state,
            form.shipping_zip,
        ],
        ([address, city, state, zip]) => {
            if (address && city && state && zip) {
                trackEnteredInfo("entered_ship_info");
            }
        }
    );
    
    watch(
        form,
        (newVal) => {
            /** change reactive address fields only if they don't match the form's fields */
            const hasStreet1 = newVal.shipping_address != null && newVal.shipping_address != '';
            const hasCity = newVal.shipping_city != null && newVal.shipping_city != '';
            const hasState = newVal.shipping_state != null && newVal.shipping_state != '';
            const hasZip = newVal.shipping_zip != null && newVal.shipping_zip != '';
            const completeShippingAddress = hasStreet1 && hasCity && hasState && hasZip;
            const diffShippingStreet1 = reactiveAddress.value.street1 != newVal.shipping_address;
            const diffShippingStreet2 = reactiveAddress.value.street2 != newVal.shipping_address2;
            const diffShippingCity = reactiveAddress.value.city != newVal.shipping_city;
            const diffShippingState = reactiveAddress.value.state != newVal.shipping_state;
            const diffShippingZip = reactiveAddress.value.postal_code != newVal.shipping_zip;

            // set taxpayload on store
            setTaxPayload(newVal);

            if (diffShippingStreet1) {
                reactiveAddress.value.street1 = newVal.shipping_address;
            }
            if (diffShippingStreet2) {
                reactiveAddress.value.street2 = newVal.shipping_address2;
            }
            if (diffShippingCity) {
                reactiveAddress.value.city = newVal.shipping_city;
            }
            if (newVal.shipping_state && diffShippingState) {
                reactiveAddress.value.state = newVal.shipping_state;
                const { data: stateUpdateListData } = useFetch(route('updatelist'),{
                    beforeFetch: (ctx) => {
                        ctx.options.headers = {
                            ...ctx.options.headers,
                            'Accept': 'application/json',
                        };
                        return ctx;
                        
                    },
                }).post({
                    state: newVal.shipping_state
                }).json();

                shippingStateForRates.value = newVal?.shipping_state;
                getShippingRates();
            }
            if (diffShippingZip) {
                reactiveAddress.value.postal_code = newVal.shipping_zip;
            }
            if(completeShippingAddress && (diffShippingStreet1 || diffShippingStreet2 || diffShippingCity || diffShippingState || diffShippingZip)){
                recalculateTax();
                reapplyCoupon();
            }
        },
        {
            deep: true
        }
    );

    watch(()=>(form.shipping_option), (newVal,oldVal)=>{
        if(newVal?.methodValue != oldVal?.methodValue){
            recalculateTax();
            reapplyCoupon();
        }
    })

    const shippingCost = computed(()=>{
        return form.shipping_option?.cost ?? 0;
    })
    watch(shippingCost, (newVal,oldVal)=>{
        if(newVal != oldVal){
            recalculateTax();
        }
    })
    
    watch(orderLineTotalWithDiscount, (newVal) => {
        if (newVal > usePage().props.d2c_expedited_shipping_max_cart_total && form.shipping_option) {
            const selectedMethod = form.shipping_option.methodValue;
            if (selectedMethod === 'twoday' || selectedMethod === 'threeday') {
                const groundMethod = shippingMethods.value.find((method) => method.methodValue === 'standard');
                if (groundMethod) {
                    form.shipping_option = groundMethod;
                }
            }
        }
    }, { deep: true })
    

    // Tax
    const allowPlaceOrder = computed(()=>{
        return !form.hasErrors && !isLoadingCalculation.value && !restrictedItems.value.length && !taxErrorMessage.value && !emailUpdateBlocksOrder.value;
    })

    const submitOrderForm = ()=>{
        const couponCodeInUse = JSON.parse(JSON.stringify(couponCode.value));
        form.transform((data)=>{
            data.card_number = data?.card_number?.replace(/\D/g, "") ?? "";
            data.shipping_option = data.shipping_option.methodValue;
            delete data.password;
            delete data.confirm_password;

       if (!["card", "gift", "paypal", "stripe_express_checkout"].includes(selectedPaymentMethod.value)) {
            data.card_id = selectedExistingCreditCard.value.gateway_id;
            data.payment_method = "card";
        } else {
            data.payment_method = selectedPaymentMethod.value;
        }

            return {
                ...data
            }
        })
        .post(route("shop.process"), {
            preserveScroll: 'errors',
            onBefore: visit => {
                clearCoupon();
            },
            onSuccess: ()=>{
                if(window.sentry){
                    let replay = window.sentry.getReplay();
                    replay.stop();
                }
                resetStore();
            },
            onError: async (errors)=>{
                couponCode.value = couponCodeInUse;
                for(let key in (errors ?? {})){
                    if (key === 'stripe_authorization_cancelled') {
                        continue;
                    }
                    form.setError({
                        [key]: errors[key]
                    });
                }
                if (errors?.stripe_authorization_cancelled) {
                    await clearCancelledStripeAuthorization(errors.payment);
                }
                nextTick(()=>{
                    if(Object.keys(errors).includes('payment')){
                        paymentErrors.value.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }else if(Object.keys(errors).includes('error')){
                        checkoutErrors.value.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                })
            }
        })
    }

    const clearCancelledStripeAuthorization = async (paymentError = null) => {
        if (!form.stripe_payment_intent_id) {
            form.clearErrors('stripe_authorization_cancelled');
            return;
        }

        const payment = paymentError ?? form.errors.payment;
        form.clearErrors('stripe_authorization_cancelled', 'payment');
        form.stripe_payment_intent_id = null;
        await form.validate();
        if (payment) {
            form.setError('payment', Array.isArray(payment) ? payment[0] : payment);
        }
    };

    const quickCreateUserErrors = ref(null);

    function placeOrder() {
        if(form.processing){
            return;
        }
        quickCreateUserErrors.value = null;

        if(allowPlaceOrder.value){
            if(form.quick_account_create && !props?.user?.user_id){
                useFetch(
                    route('b2c.create.account'),
                    {
                        beforeFetch(ctx) {
                            ctx.options.headers = {
                                ...ctx.options.headers,
                                'Accept': 'application/json',
                            };
                            return ctx;
                        },
                        afterFetch(ctx) {
                            if(ctx?.data?.errors){
                                quickCreateUserErrors.value = ctx.data.errors;
                                scrollToTop();
                            }
                            else submitOrderForm();
                            return ctx;
                        },
                        onFetchError(ctx) {
                            if(ctx.data.errors){
                                quickCreateUserErrors.value = ctx.data.errors;
                                scrollToTop();
                            }
                            return ctx;
                        }
                    }
                )
                .post({
                    'login-email': form.email,
                    'login-password': form.password,
                    'confirm-password': form.confirm_password
                })
                .json();
            }else{
                submitOrderForm();
            }
        } 
    }

    const login = ref(null);
    const authorizationTab = ref(usePage().props?.flash?.twoFactorAuth?.fa_enabled ? 'tab2' : 'tab1')
    
    const openLoginTab = ()=>{
        authorizationTab.value = 'tab2';
        nextTick(()=>{
            login?.value?.$refs?.emailInput?.setFocus();
        })
    }

    const userLoggedIn = ()=>{
        //unset quick account create fields
        form.quick_account_create = false;
        form.password = "";
        form.confirm_password = "";

        if(window.sentry){
            window.sentry.setUser({
                email: props.user.email,
            });
        }
    }

    const onShippingUpdated = () => {
        trackViewedShipping();
        gtmAddShippingInfoEvent(completeOrderTotal.value);
    };

    const onCreditCardUpdated = () => {
        gtmAddPaymentInfoEvent(completeOrderTotal.value);
    };

    const handleStripeExpressCheckoutSuccess = (paymentData) => {
        form.stripe_payment_intent_id = paymentData.payment.paymentIntentId;
        trackEnteredInfo("entered_bill_info");
        
        gtmAddPaymentInfoEvent(completeOrderTotal.value);

        nextTick(() => {
            placeOrder();
        });
    };

    let removeFinishRouterEvent = ()=>{};

    const couponItems = computed(() => {
        return couponInformation.value.items?.filter((item)=>(item.new == true))
    })

    const completeOrderTotal = computed(()=>{
        return formatPrice(+orderLineTotalWithDiscount.value + (form.shipping_option?.cost ?? 0 ) + +taxAmount.value);
    })

    const canProcessPaypal = computed(()=>{
        return !isUpdatingCartItem.value && !isLoadingCalculation.value;
    })

    const hasNonPaymentErrors = computed(() => {
        const errors = form.errors || {};
        const nonPaymentErrors = Object.keys(errors).filter(key => {
            const lowerKey = key.toLowerCase();
            return lowerKey !== 'payment' &&
                   !lowerKey.startsWith('stripe') && 
                   !lowerKey.startsWith('card') && 
                   !lowerKey.startsWith('paypal');
        });
        
        return nonPaymentErrors.length > 0;
    });

    const canProcessStripeExpressCheckout = computed(()=>{
        return !hasNonPaymentErrors.value && !isUpdatingCartItem.value && !isLoadingCalculation.value && !restrictedItems.value.length && !taxErrorMessage.value && !emailUpdateBlocksOrder.value;
    })


    let paypalAttempted = ref(false);

    onMounted(() => {

        if(window.sentry){
            let replay = window.sentry.getReplay();
            replay.start();
        }
        gtmBeginCheckoutEvent(completeOrderTotal.value)
        window.addEventListener("beforeunload", beforeUnloadHandler);

        if(form.shipping_option){
            gtmAddShippingInfoEvent(completeOrderTotal.value)
        }

        if(form.payment_method){
            gtmAddPaymentInfoEvent(completeOrderTotal.value)
        }

        if(![null,undefined].includes(usePage().props.free_shipping_amount)){
            setFreeShippingAmount(usePage().props.free_shipping_amount);
        }

        removeFinishRouterEvent = router.on('finish', ()=>{
            if(usePage().props.flash?.globalMessage){
                setNotificationMessage(usePage().props.flash.globalMessage);
            }

            if(![null,undefined].includes(usePage().props.free_shipping_amount)){
                setFreeShippingAmount(usePage().props.free_shipping_amount);
            }
        })
        form.validate({all: true});

        form.add_billing_info = "0";
        if (!["paypal", "gift", "card", "stripe_express_checkout"].includes(selectedPaymentMethod.value)) {
            selectedExistingCreditCard.value =
                props.checkoutResource.cards.find(
                    (card) => card.consumer_credit_card_id == selectedPaymentMethod.value
                );
            form.payment_method = selectedPaymentMethod.value
        } else if (
            ["paypal", "gift", "card", "stripe_express_checkout"].includes(selectedPaymentMethod.value)
        ) {
            selectedExistingCreditCard.value = null;
            form.payment_method = selectedPaymentMethod.value;
        }
        loadScript({
            "client-id": props.ppClientId,
            intent: "authorize"
        }).then((paypal) => {
            paypal
                .Buttons({
                    onInit(data, actions) {
                        watch(()=>(canProcessPaypal.value), (newVal)=>{
                            if (newVal) {
                                actions.enable();
                            } else {
                                actions.disable();
                            }
                        },{immediate: true})
                    },
                    createOrder: function (data, actions) {
                        return actions.order.create({
                            intent: 'AUTHORIZE',
                            purchase_units: [
                                
                                {
                                    shipping: {
                                        name: {
                                            full_name: `${form.shipping_first_name + (form.shipping_last_name ? ' ' + form.shipping_last_name : '')}`
                                        },
                                        address: {
                                            address_line_1: form.shipping_address,
                                            address_line_2: form.shipping_address2,
                                            admin_area_2: form.shipping_city,
                                            admin_area_1: form.shipping_state,
                                            postal_code: form.shipping_zip,
                                            country_code: "US"
                                        }
                                    },
                                    amount: {
                                        value: +completeOrderTotal.value,
                                        currency_code: "USD",
                                        breakdown: {
                                            item_total: {
                                                currency_code: "USD",
                                                value: +orderLineTotalWithDiscount.value
                                            },
                                            shipping: {
                                                currency_code: "USD",
                                                value: +form.shipping_option?.cost
                                            },
                                            tax_total: {
                                                currency_code: "USD",
                                                value: +taxAmount.value.toFixed(2)
                                            }
                                        }
                                    }
                                }
                            ]
                        });
                    },
                    onApprove: function (data, actions) {
                        form.paypal_order_id = data.orderID;
                        form.paypal_amount = +completeOrderTotal.value;
                        paypalAttempted.value = true;
                        trackEnteredInfo("entered_bill_info");
                    }
                })
                .render("#paypal-button-container");
        });

       
    });

    onUnmounted(()=>{
        removeFinishRouterEvent();
    })
    onBeforeUnmount(() => {
        window.removeEventListener("beforeunload", beforeUnloadHandler);
    });

    //make computed versions all all routes in template
    let homeRoute = computed(()=>route('home'));
    let logoutRoute = computed(()=>route('web.logout'));
    let termsAndConditionsRoute = computed(()=>route('index.cms', 'rothco-terms-conditions'));
    let privacyPolicyRoute = computed(()=>route('index.cms', 'rothco-privacy-policy'));
    let returnPolicyRoute = computed(()=>route('customer-service.cms', 'consumer-return-policy'));
    let helpRoute = computed(()=>route('customer-service.index'));


    watch(completeOrderTotal, (newVal)=>{
        if(form.paypal_order_id){
            form.paypal_order_id = null;
            form.paypal_amount = null;
        }
    })
</script>
<style lang="scss" scoped>
.flex {
    display: flex;
}
</style>
